import { CareType } from '@uplift/api';

export const getCareTypeLabel = (careType: CareType): string => {
  const labels = {
    [CareType.therapy]: 'Therapy',
    [CareType.psychiatry]: 'Psychiatry',
    [CareType.therapyAndPsychiatry]: 'Therapy and Psychiatry',
  };

  return labels[careType] || 'Unknown Care Type';
};
